import { Component, ElementRef, OnInit, Inject } from '@angular/core';
import { TranslationService } from '../services/common/translation.service';
import { Culture } from '../models/common/culture';
import { getLangDir } from 'rtl-detect';
import { DOCUMENT } from '@angular/platform-browser';

@Component({
  selector: 'app',
  template: require('./../templates/app.component.html'),
  styles: [require('./../styles/app.component.css')]
})
export class AppComponent implements OnInit {

  constructor(private elementRef: ElementRef, @Inject(DOCUMENT) private document: Document) {
    var defaultCulture = this.getCulture('defaultCultureCode', 'defaultCultureTitle');
    var explicitCulture = this.getCulture('explicitCultureCode', 'explicitCultureTitle');

    if (explicitCulture.code) {
      TranslationService.explicitCulture = explicitCulture;
    }
    else if (TranslationService.isDefaultCultureEmpty() && defaultCulture.code) {
      TranslationService.currentCulture = defaultCulture;
    }
  }

  getCulture(code: string, title: string): Culture {
    var culture = new Culture();
    culture.code = this.elementRef.nativeElement.getAttribute(code);
    culture.title = this.elementRef.nativeElement.getAttribute(title);
    return culture;
  }

  ngOnInit() {
    this.document.dir = getLangDir(TranslationService.currentCulture.code);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./ClientApp/app/components/app.component.ts